module.exports = __webpack_public_path__ + "img/TrolleyTray.c8a1d958.jpg";